import { Link } from "react-router-dom";

const Search = () => {
  //

  return (
    <div id="search" style={{ color: "white" }}>
      <Link to={"/"} style={{ fontSize: "1.3em" }}>
        Redcar &#128154;
      </Link>
    </div>
  );
};

export default Search;
